import moment from 'moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import PropertyField from '../../../../components/Properties/PropertyField';

function NewsPanel({ news, loading, isOpen, onCreate, onUpdate, onClose, duplicationMode }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [publicationDate, setPublicationDate] = useState(undefined);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (news) {
      setTitle(news.title);
      setContent(news.content);
      setPublicationDate(new Date(news.publication_date));
      setTags(news?.tags?.map((t) => t.id));
    } else {
      setTitle('');
      setContent('');
      setPublicationDate(new Date());
      setTags([]);
    }
  }, [news, onCreate, onUpdate]);

  const handleValidate = () => {
    const newsPayload = {
      title,
      content,
      tags,
      publication_date: moment(publicationDate).format('YYYY-MM-DD')
    };
    if (!news || duplicationMode) onCreate(newsPayload);
    else onUpdate(newsPayload);
  };

  const formIsValid = () => {
    return title.length > 3 && content.length > 3 && tags.length;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider l'article`}
        loading={loading}
        disabled={!formIsValid()}
        onClick={handleValidate}
        severity="success"
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: '80vw' }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${!news || duplicationMode ? 'Ajouter' : 'Modifier'} une actualité`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="grid grid-cols-2 gap-5 h-full overflow-y-hidden">
          <div className="flex flex-col gap-y-3 ">
            <FormInput
              key="content"
              label={'Contenu'}
              required
              isValid={content.length > 3}
              helpMessage={'Maintenez la touche Alt enfoncée pour conserver le ratio des images'}
              className="grow">
              <RichTextEditor
                value={content}
                onChange={(value) => {
                  setContent(value);
                }}
                acceptImage
                acceptHeaders
                height={'65vh'}
              />
            </FormInput>
            {footerButtons}
          </div>
          <div className="form-wrapper overflow-y-scroll h-auto">
            <FormInput
              label={'Titre (utilisé également pour le Titre SEO)'}
              required
              isValid={title.length > 3}>
              <InputText
                id="title"
                value={title}
                maxLength={300}
                placeholder="Veuillez saisir le titre de l'article"
                onChange={(e) => setTitle(e.target.value)}
              />
            </FormInput>
            {/* <div className="grid grid-cols-2 gap-3"> */}
            <FormInput label={"Type d'article"} required isValid={tags.length}>
              <PropertyField
                type={'qb_thematique'}
                selectedPropertyList={tags}
                setSelectedPropertyList={setTags}
                scope={'quatrebis'}
              />
            </FormInput>
            <FormInput label={'Date de publication'} required isValid={publicationDate}>
              <Calendar
                id="publication-date"
                onChange={(e) => setPublicationDate(e.value)}
                dateFormat="dd/mm/yy"
                placeholder="Veuillez selectionner la date de publication"
                maxDate={new Date()}
                value={publicationDate}
                locale="fr"
              />
            </FormInput>
            {/* </div> */}
          </div>
        </div>
      </div>
    </Sidebar>
  );
}

export default NewsPanel;
